var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaticIcn4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "static-icn4",
    transform: "translate(-1207 -1203)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_278",
    "data-name": "Rectangle 278",
    width: 104,
    height: 104,
    rx: 10,
    transform: "translate(1207 1203)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2404",
    "data-name": "Groupe 2404",
    transform: "translate(1171.722 1145.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2906",
    "data-name": "Trac\\xE9 2906",
    d: "M58,267.1c.2-.941.347-1.9.611-2.82a15.086,15.086,0,0,1,14.352-10.918c1.175-.012,2.351,0,3.6,0,.2,1.188.314,2.383.618,3.527.556,2.093.067,4.126-.2,6.173-.417,3.248-.871,6.491-1.312,9.736a2.192,2.192,0,0,0,.553,1.741c1.675,2.076,3.335,4.164,5,6.249.116.145.226.3.426.559H80.9c-6.786,0-13.573-.019-20.359.018A2.431,2.431,0,0,1,58,279.96Z",
    transform: "translate(0 -143.156)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2907",
    "data-name": "Trac\\xE9 2907",
    d: "M141.734,81.208a12.606,12.606,0,1,1-12.62,12.561A12.61,12.61,0,0,1,141.734,81.208Z",
    transform: "translate(-59.137)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2908",
    "data-name": "Trac\\xE9 2908",
    d: "M306.071,332.217c0,3.376.18,6.721-.057,10.037a5.3,5.3,0,0,1-5.361,4.656q-8.157.051-16.314,0a5.637,5.637,0,0,1-5.5-5.148c-.027-.292-.02-.587-.02-.881,0-2.874,0-5.747,0-8.663Z",
    transform: "translate(-183.628 -208.734)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2909",
    "data-name": "Trac\\xE9 2909",
    d: "M278.806,237.257a5.893,5.893,0,0,1,6.712-6.875c0-1.066-.018-2.067,0-3.067.047-2.092,1.172-3.867,3.084-4.255a19.646,19.646,0,0,1,7.688,0,4,4,0,0,1,3.051,3.816c.064,1.129.012,2.265.012,3.5a6.022,6.022,0,0,1,5.731,2.4,6.428,6.428,0,0,1,1.012,4.483Zm16.789-6.91c0-1.06.008-2.065,0-3.069a.636.636,0,0,0-.719-.69c-1.616,0-3.232-.021-4.847.023-.235.006-.652.3-.663.487-.063,1.075-.031,2.155-.031,3.25Z",
    transform: "translate(-183.582 -117.644)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2910",
    "data-name": "Trac\\xE9 2910",
    d: "M219.5,281.3H209.81c.137-.2.228-.352.337-.489,1.651-2.067,3.293-4.142,4.964-6.194a2.6,2.6,0,0,0,.585-2.155c-.619-4.406-1.223-8.814-1.758-13.23a8.44,8.44,0,0,1,.3-2.232c.191-1.2.394-2.4.6-3.668,2.285.052,4.548-.176,6.849.41-.187.157-.324.276-.464.391a9.29,9.29,0,0,0-3.569,7.4c-.025,4.684-.008,9.368-.006,14.052a9.371,9.371,0,0,0,1.618,5.338C219.336,281.024,219.393,281.13,219.5,281.3Z",
    transform: "translate(-126.242 -143.137)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2911",
    "data-name": "Trac\\xE9 2911",
    d: "M187.815,298.429h3c.259,1.923.516,3.829.773,5.736.235,1.746.455,3.493.715,5.235a1.375,1.375,0,0,1-.324,1.2c-.889,1.056-1.735,2.149-2.657,3.3-.784-.977-1.487-1.938-2.281-2.816a2.422,2.422,0,0,1-.646-2.2C186.914,305.424,187.343,301.948,187.815,298.429Z",
    transform: "translate(-106.731 -180.637)",
    fill: "#06d2e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2912",
    "data-name": "Trac\\xE9 2912",
    d: "M191.684,257.326l-.618-3.688h4.34l-.609,3.688Z",
    transform: "translate(-110.655 -143.389)",
    fill: "#06d2e0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticIcn4);
export default __webpack_public_path__ + "static/media/static-icn4.f48ef41c29a59d0d21ed959b477152cf.svg";
export { ForwardRef as ReactComponent };